import React, { memo } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import { Pills } from '../Options/Pills.tsx';

import { TaskView } from './tasksDefinitions.ts';

const i18n = defineMessages({
	tasksAssignedToMe: {
		id: 'home.views.tasks.assigned.pill',
		defaultMessage: 'Assigned to me <b>{count}</b>',
		description: 'Filter option to display tasks assigned to the user',
	},
	tasksCreatedByMe: {
		id: 'home.views.tasks.created.pill',
		defaultMessage: 'Created by me <b>{count}</b>',
		description: 'Filter option to display tasks created by the user',
	},
});

interface TaskViewPillProps {
	tasksLength?: number;
	createdTasksLength?: number;
	selectedTableView: TaskView;
	setSelectedTableView: (tableView: TaskView) => void;
}

export const TaskViewPills = memo(
	({
		tasksLength,
		createdTasksLength,
		selectedTableView,
		setSelectedTableView,
	}: TaskViewPillProps) => {
		let assignedCount = '0';
		let createdCount = '0';

		if (tasksLength) {
			assignedCount = tasksLength > 99 ? '99+' : String(tasksLength);
		}

		if (createdTasksLength) {
			createdCount = createdTasksLength > 99 ? '99+' : String(createdTasksLength);
		}

		const pills = [
			{
				name: TaskView.Assigned,
				i18n: (
					<FormattedMessage
						{...i18n.tasksAssignedToMe}
						values={{
							count: assignedCount,
							b: (text) => <b>{text}</b>,
						}}
					/>
				),
			},
			{
				name: TaskView.Created,
				i18n: (
					<FormattedMessage
						{...i18n.tasksCreatedByMe}
						values={{
							count: createdCount,
							b: (text) => <b>{text}</b>,
						}}
					/>
				),
			},
		];

		return (
			<Pills
				pill={selectedTableView}
				pills={pills}
				setPill={(pill) => setSelectedTableView(pill as TaskView)}
			/>
		);
	},
);
